import type { HistoricalEvidenceProvenance } from "@/lib/api/courseHistory";

/** True when a provider evidence row carries any source value or conflict; a file import's empty row reads as no provider evidence. */
export function hasSourceEvidence(value: HistoricalEvidenceProvenance | null | undefined): boolean {
  if (!value) return false;
  const { conflicts, receipt_ids: _r, batch_ids: _b, ...fields } = value;
  return conflicts.length > 0 || Object.values(fields).some((v) => v !== null && v !== undefined);
}
